import { Row, Col, Alert } from 'react-bootstrap';
import RenderSection from './RenderSection';
import { prepareABTestData } from './prepareABTestData';
import { formatPrice } from './functions';

const CartABLayout = ({ cart, labels, continuity, isPR, plan }) => {
  const {
    todaysItems,
    totalToday,
    month1Items,
    month1Total,
    month12Items,
    month12Total,
  } = prepareABTestData(cart, labels, plan);

  let achDisclaimerCopyComponent;
  if (continuity !== 'Continuity' && !isPR) {
    achDisclaimerCopyComponent = (
      <Row className="ach-disclaimer">
        <Col sm={{ span: 8 }} md={{ span: 9 }}>
          <h6>{labels.achDisclaimer}</h6>
        </Col>
      </Row>
    );
  }

  return (
    <>
      <Row className="mt-3">
        <Col>
          <Alert>
            <h3>Cart Preview</h3>
          </Alert>
        </Col>
      </Row>

      <RenderSection title={labels.todayCharges} items={todaysItems} />
      <RenderSection title={labels.firstMonthCharges} items={month1Items} />
      <RenderSection
        title={labels.month2to11Charges}
        items={[{ Item: labels.monthlyTotal, Price: month1Total }]}
      />
      <RenderSection title={labels.afterYearCharges} items={month12Items} />

      <div className="section">
        <Row>
          <Col>
            <h5>{labels.summary}</h5>
          </Col>
        </Row>
        <Row>
          <Col xs={5}>{labels.todayCharges}</Col>
          <Col xs={4}>{formatPrice(totalToday)}</Col>
        </Row>
        <Row>
          <Col xs={5}>{labels.firstMonthCharges}</Col>
          <Col xs={4}>{formatPrice(month1Total)}</Col>
        </Row>
        <Row>
          <Col xs={5}>{labels.month2to11Charges}</Col>
          <Col xs={4}>{formatPrice(month1Total)} /month</Col>
        </Row>
        <Row>
          <Col xs={5}>{labels.afterYearCharges}</Col>
          <Col xs={4}>{formatPrice(month12Total)} /month</Col>
        </Row>
      </div>

      {achDisclaimerCopyComponent}
    </>
  );
};

export default CartABLayout;
